import { Hint, Step } from "intro.js";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import create_new_layers from "shared/assets/onboarding/create_new_layers.gif";
import difference_view_and_edit from "shared/assets/onboarding/difference_view_and_edit.png";
import edit_layers from "shared/assets/onboarding/edit_layers.gif";
import feature_infos from "shared/assets/onboarding/feature_infos.gif";
import first_step_edit from "shared/assets/onboarding/first_step_edit.jpg";
import last_step from "shared/assets/onboarding/last_step.jpg";
import map_location from "shared/assets/onboarding/map_location.gif";
import measurements from "shared/assets/onboarding/measurements.gif";

export const EditSteps = (linref: boolean) => {
  const { t } = useTranslation();

  const steps = useMemo(() => {
    const introductionSteps: Array<Step> = [
      {
        title: t("onboarding_edit.title_1") as string,
        intro:
          `<img loading='lazy' alt='Designed by pch.vector / Freepik' src='${first_step_edit}'/>` +
          t("onboarding_edit.description_1"),
      },
      {
        title: t("onboarding_edit.title_2") as string,
        intro:
          `<img loading='lazy' alt='Difference for view and edit' src='${difference_view_and_edit}'/>` +
          t("onboarding_edit.description_2"),
        tooltipClass: "infra3d-introductionBox-big",
      },
      {
        element: ".mapillary-direction-perspective",
        position: "top",
        title: t("onboarding_edit.title_3") as string,
        intro: t("onboarding_edit.description_3"),
      },
      {
        element: "#cockpit",
        position: "top",
        title: t("onboarding_edit.title_4") as string,
        intro: linref
          ? t("onboarding_edit.description_4_linref")
          : t("onboarding_edit.description_4"),
      },
      {
        element: ".onboarding-mapBox",
        position: "left",
        title: t("onboarding_edit.title_5") as string,
        intro:
          `<img loading='lazy' alt='Map tutorial' src='${map_location}'/>` +
          t("onboarding_edit.description_5"),
      },
      {
        element: "#toolbar",
        position: "right",
        title: t("onboarding_edit.title_6") as string,
        intro: t("onboarding_edit.description_6"),
      },
      {
        element: ".onboarding-layertree",
        position: "right",
        title: t("onboarding_edit.title_7") as string,
        intro: t("onboarding_edit.description_7"),
      },
      {
        element: ".onboarding-webServices",
        position: "right",
        title: t("onboarding_edit.title_8") as string,
        intro:
          `<img loading='lazy' alt='Create new layer tutorial' src='${create_new_layers}'/>` +
          t("onboarding_edit.description_8"),
      },
      {
        element: ".onboarding-featureTable",
        position: "right",
        title: t("onboarding_edit.title_9") as string,
        intro: t("onboarding_edit.description_9"),
      },

      {
        element: ".onboarding-featureInfo",
        position: "right",
        title: t("onboarding_edit.title_10") as string,
        intro:
          `<img loading='lazy' alt='Feature info tutorial' src='${feature_infos}'/>` +
          t("onboarding_edit.description_10"),
      },
      {
        element: "#infra3d-axisVisibilityPanelButton",
        position: "right",
        title: t("onboarding_edit.title_11") as string,
        intro: t("onboarding_edit.description_11"),
      },
      {
        element: ".onboarding-cursor",
        position: "right",
        title: t("onboarding_edit.title_12") as string,
        intro: t("onboarding_edit.description_12"),
      },
      {
        element: ".onboarding-measurement",
        position: "right",
        title: t("onboarding_edit.title_13") as string,
        intro:
          `<img loading='lazy' alt='Measure' src='${measurements}'/>` + linref
            ? t("onboarding_edit.description_13_linref")
            : t("onboarding_edit.description_13"),
      },
      {
        element: ".onboarding-editTools",
        position: "right",
        title: t("onboarding_edit.title_14") as string,
        intro:
          `<img loading='lazy' alt='Edit layers' src='${edit_layers}'/>` +
          t("onboarding_edit.description_14"),
      },
      {
        element: ".onboarding-imageInformation",
        position: "right",
        title: t("onboarding_edit.title_15") as string,
        intro: t("onboarding_edit.description_15"),
      },
      {
        element: ".onboarding-shareLink",
        position: "right",
        title: t("onboarding_edit.title_16") as string,
        intro: t("onboarding_edit.description_16"),
      },
      {
        element: ".onboarding-campaignSwitch",
        position: "left",
        title: t("onboarding_edit.title_17") as string,
        intro: t("onboarding_edit.description_17"),
      },
      {
        element: ".onboarding-knowledgeBase",
        position: "left",
        title: t("onboarding_edit.title_18") as string,
        intro: t("onboarding_edit.description_18"),
      },
      {
        element: "#logo",
        position: "left",
        title: t("onboarding_edit.title_19") as string,
        intro: t("onboarding_edit.description_19"),
      },
      {
        element: ".onboarding-platform",
        position: "left",
        title: t("onboarding_edit.title_20") as string,
        intro: t("onboarding_edit.description_20"),
      },
      {
        title: t("onboarding_edit.title_21") as string,
        intro:
          `<img loading='lazy' alt='Designed by pch.vector / Freepik' src='${last_step}'/>` +
          t("onboarding_edit.description_21"),
      },
    ];

    const whatsnewSteps: Array<Step> = [];

    const whatsnewHints: Array<Hint> = [
      {
        element: "#infra3d-basemap-button",
        hint: t("whatsnew.hint_1"),
      },
    ];

    return { introductionSteps, whatsnewSteps, whatsnewHints };
  }, [t, linref]);

  return steps;
};
